import { GA_MEASUREMENT_ID, isGoogleAnalyticsAllowedOnCurrentHost } from '../config/googleAnalytics';

/** OpenPanel funnel names → GA4 recommended event names (custom names kept for page lands). */
const GA4_FUNNEL_EVENT_NAMES = {
  ViewContent: 'view_item',
  AddToCart: 'add_to_cart',
  InitiateCheckout: 'begin_checkout',
  Purchase: 'purchase',
};

function gaItemFromContentProps(props) {
  const id = String(props.content_id || '').trim();
  if (!id) return null;
  return {
    item_id: id,
    item_name: String(props.content_name || id),
    item_category: String(props.content_type || 'product'),
  };
}

/** Map OpenPanel-style payload to gtag event params (UTMs + ecommerce fields). */
export function buildGAEventParams(props = {}) {
  const params = { ...(props && typeof props === 'object' ? props : {}) };

  if (params.__query && typeof params.__query === 'object') {
    for (const [key, value] of Object.entries(params.__query)) {
      if (value != null && String(value).trim() && params[key] == null) {
        params[key] = value;
      }
    }
    delete params.__query;
  }

  const item = gaItemFromContentProps(params);
  if (item) {
    params.items = [item];
  }

  if (params.booking_id && !params.transaction_id) {
    params.transaction_id = String(params.booking_id);
  }

  return params;
}

/**
 * Mirror OpenPanel custom / funnel events into GA4 (same call sites as OpenPanel).
 * Funnel events use GA4 recommended names; page lands keep names like HomepageLanded.
 */
export function trackGoogleAnalyticsMirrorEvent(openPanelEventName, props = {}) {
  if (!isGoogleAnalyticsAllowedOnCurrentHost()) return;
  if (typeof window.gtag !== 'function') return;

  const openName = String(openPanelEventName || '').trim();
  if (!openName) return;

  const gaEventName = GA4_FUNNEL_EVENT_NAMES[openName] || openName;
  const params = buildGAEventParams(props);

  window.gtag('event', gaEventName, params);
}

export function trackGAPageView(pagePath) {
  if (!isGoogleAnalyticsAllowedOnCurrentHost()) return;
  if (typeof window.gtag !== 'function') return;

  const path =
    pagePath ||
    `${window.location.pathname || '/'}${window.location.search || ''}`;

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: path,
  });
}
